export class AutoCompleteEnvironment {
  public static getName = () => 'benzinga-autocomplete';
  public static getEnvironment = (env: Record<string, string>) => ({
    fundsUrl: new URL(env.fundsUrl ?? 'https://www.benzinga.com'),
    symbolsKey: env.symbolsKey ?? 'aH0FkLCohY5yxK6OEaJ28Zpv51Ze1GyY',
    symbolsUrl: new URL(env.symbolsUrl ?? 'https://data-api-pro.benzinga.com/rest/'),
  });
}
